import * as t from 'io-ts';

export const UserSessionStateC = t.type({
    shouldLogout: t.boolean,
    reason: t.union([t.string, t.null]),
    isAccountDeleted: t.boolean,
});

export type UserSessionState = t.TypeOf<typeof UserSessionStateC>;
